import { render, staticRenderFns } from "./InvoiceCreate.vue?vue&type=template&id=ef4c7c68&scoped=true"
import script from "./InvoiceCreate.vue?vue&type=script&lang=js"
export * from "./InvoiceCreate.vue?vue&type=script&lang=js"
import style0 from "./InvoiceCreate.vue?vue&type=style&index=0&id=ef4c7c68&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef4c7c68",
  null
  
)

export default component.exports